import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { DSRESTClient } from '../shared/communication-objects/restclient.service';
import { AppDialogService } from './app-dialog.service';
import { LogService } from './log.service';
import { AlarmTypes } from '@components/alarm-email-form/alarm-email-form.component';
import { map, Observable, tap } from 'rxjs';
import {
  IEmailAlertFormItem,
  IEmailAlertFormResponse,
} from '@interfaces/email-alerts-form';

@Injectable({
  providedIn: 'root',
})
export class AlarmService {
  readonly apiURL: string = 'alarm';

  constructor(
    private restClient: DSRESTClient,
    private logger: LogService,
    private _ads: AppDialogService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {}

  saveAlarmDefinitions(
    alarms: any[],
  ): Observable<any> {
    const url = `${this.apiURL}/save-alarms`;
    const payload = { AlarmDefinitions: alarms };
    return this.restClient.postForResponse<object>(url, payload);
  }

  getAlarmDefinitions(
    alarmType: AlarmTypes,
    entityId: number,
  ): Observable<IEmailAlertFormResponse> {
    const url = `${this.apiURL}/by-alarm-type/${alarmType}/${entityId}`;
    return this.restClient.getDirect<IEmailAlertFormItem[]>(url).pipe(
      map((response) => {
        return {
          emailAlertFormItems: response,
        };
      }),
    );
  }

  emailExistsAlreadyInDb(
    alarmType: AlarmTypes,
    entityId: number,
    emailAddress: string,
  ): Observable<number> {
    const url = `${this.apiURL}/verify-email`;
    return this.restClient
      .postForResponse<number>(url, { emailAddress: emailAddress })
      .pipe(
        tap((response) => {
          this.logger.log('Email Exists Already In DB', response);
        }),
      );
  }
}
